<script setup lang="ts">
import { MenuButton } from '@headlessui/vue'
import { PlusIcon } from '@heroicons/vue/20/solid'
import type { HTMLAttributes } from 'vue'
import PromptInputButton from './PromptInputButton.vue'

interface Props {
  class?: HTMLAttributes['class']
  disabled?: boolean
}

const props = defineProps<Props>()
</script>

<template>
  <MenuButton as="template" :disabled="props.disabled">
    <PromptInputButton
      :class="props.class"
      :disabled="props.disabled"
      v-bind="$attrs"
    >
      <slot>
        <PlusIcon class="h-4 w-4" />
      </slot>
    </PromptInputButton>
  </MenuButton>
</template>
